<a
  href="#main-content"
  class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[1000] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-blue-700 focus:shadow-md focus:outline focus:outline-2 focus:outline-blue-700"
>
  Skip to main content
</a>

@if (displayLoadingSpinner()) {
  <div
    class="loading-overlay app-component"
    role="status"
    aria-label="Loading application, please wait"
  >
    <div class="loading-spinner">
      <mat-spinner [diameter]="100" aria-hidden="true"></mat-spinner>
    </div>
  </div>
}

<router-outlet></router-outlet>
